import { render, staticRenderFns } from "./TrademarkAgendaReport.vue?vue&type=template&id=eeea70e2&"
import script from "./TrademarkAgendaReport.vue?vue&type=script&lang=js&"
export * from "./TrademarkAgendaReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports